module.exports = __webpack_public_path__ + "b0bb42a59f0c333628747fa7820fe322.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/retro-camera.png
// module id = 1984
// module chunks = 0